import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { config } from "../config/env";
import { isConversionPath } from "../hooks/useContentsquare";

let scriptInjected = false;

function injectMauticScript(baseUrl) {
  if (scriptInjected || typeof window === "undefined") return;
  const src = `${baseUrl.replace(/\/$/, "")}/mtc.js`;

  window.MauticTrackingObject = "mt";
  window.mt =
    window.mt ||
    function mt() {
      (window.mt.q = window.mt.q || []).push(arguments);
    };

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
  scriptInjected = true;
}

export function sendMauticPageview(extra = {}) {
  if (!config.mautic?.baseUrl || typeof window.mt !== "function") return;
  window.mt("send", "pageview", extra);
}

/**
 * Carrega mtc.js e envia pageview apenas em rotas de aquisição
 * (mesmo critério do Contentsquare) — não no app autenticado.
 */
export default function MauticTracking() {
  const baseUrl = config.mautic?.baseUrl;
  const location = useLocation();
  const onAcquisition = isConversionPath(location.pathname);

  useEffect(() => {
    if (!baseUrl || !onAcquisition) return;
    injectMauticScript(baseUrl);
  }, [baseUrl, onAcquisition]);

  useEffect(() => {
    if (!baseUrl || !onAcquisition) return;
    sendMauticPageview({
      page_url: window.location.href,
      page_title: document.title,
      page_path: location.pathname + location.search,
    });
  }, [baseUrl, onAcquisition, location.pathname, location.search]);

  return null;
}

/**
 * Vincula o visitante anônimo (cookie mtc_id) ao contato após captura de lead.
 */
export function identifyLeadInMautic(formData) {
  if (!config.mautic?.baseUrl) return;

  const parts = (formData.nome || "").trim().split(/\s+/).filter(Boolean);
  const payload = {
    email: formData.email,
    firstname: parts[0] || "",
    lastname: parts.slice(1).join(" ") || "",
    page_url: window.location.href,
    page_title: document.title,
  };

  if (formData.telefone) payload.phone = formData.telefone;
  if (formData.empresa) payload.company = formData.empresa;

  sendMauticPageview(payload);
}

/**
 * Identifica contato logado no Mautic (email/nome) em qualquer página.
 */
export function identifyUserInMautic({ email, nome, telefone, empresa } = {}) {
  if (!email) return;

  const parts = (nome || "").trim().split(/\s+/).filter(Boolean);
  const payload = {
    email,
    firstname: parts[0] || "",
    lastname: parts.slice(1).join(" ") || "",
    page_url: window.location.href,
    page_title: document.title,
  };

  if (telefone) payload.phone = telefone;
  if (empresa) payload.company = empresa;

  sendMauticPageview(payload);
}
